<template>
  <div class="subnav" v-if="loaded">
    <div class="container">
    </div>
  </div>
</template>

<script>
import { startsWith } from 'lodash';
import { mapActions, mapState, mapGetters } from 'vuex';
import loading from '@shared/mixins/loading';

const name = 'ii-navigation';

export default {
    name,
    componentName: name,

    mixins: [loading],

    data() {
        return {
            subnav: {
                invoices: true,
                requestToPay: false,
            },
        };
    },

    created() {
        this.startLoading();
        this.stopLoading();
    },

    computed: {
        ...mapGetters('api', ['api']),
    },

    methods: {
        isActive(routeName) {
            return startsWith(this.$route.name, routeName);
        },
    },
};
</script>




// WEBPACK FOOTER //
// shared/components/Navigation.vue